<template>
  <div class="halloween-draw">
    <div class="halloween-draw-content">
      <div class="draw">
        <div class="consume">
          本次抽獎需要消耗
          <span class="consume-num">{{ candyCostNumber }} </span>
          個糖果來安撫搗蛋鬼，安撫成功會掉落獎勵喔！
        </div>
        <div class="num-box">
          <img
            class="rules"
            src="./images/rules.png"
            alt=""
            @click="isShowRulesDialog = !isShowRulesDialog"
          />
          <el-dialog
            :visible.sync="isShowRulesDialog"
            title="糖果獲得規則說明："
            center
            :modal-append-to-body="false"
          >
            <!-- <div class="title">
              糖果獲得規則說明：
            </div> -->
            <div class="rules-item">
              1. 確認完成陪玩訂單，用戶和陪玩師雙方都可獲得糖果；
            </div>
            <div class="rules-item">
              2.
              確認完成禮物訂單，送禮方可獲得2倍禮物訂單金額數量糖果，陪玩師可獲得1倍禮物訂單金額數量糖果；
            </div>
            <div class="rules-item">
              3. 糖果長期有效，更多神秘用途正在路上
            </div>
          </el-dialog>

          <div class="num">{{ balance }}</div>
        </div>
        <LuckyGrid
          ref="myLucky"
          :width="width"
          :height="height"
          :prizes="prizes"
          :rows="rows"
          :cols="cols"
          :blocks="blocks"
          :buttons="buttons"
          :speed="100"
          :active-style="activeStyle"
          @start="clickDrawButton"
          @end="endLuck"
        />
        <div class="msg">
          所有獎品中獎後24小時內生效，可留意訊息後臺的系統領取通知使用
        </div>
        <div class="power">
          最終解釋權歸nicee所有
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MinHalloweenDraw',
  data() {
    return {
      width: '300px',
      height: '300px',
      rows: 3,
      cols: 3,
      blocks: [
        {
          padding: '24px',
          // background: '#869cfa',
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/bg.png'),
              width: '100%',
              height: '100%'
            }
          ]
        }
      ],
      prizes: [
        {
          x: 0,
          y: 0,
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/1.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/halloween-draw/images/active1.png')
            }
          ]
        },
        {
          x: 1,
          y: 0,
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/2.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/halloween-draw/images/active2.png')
            }
          ]
        },
        {
          x: 2,
          y: 0,
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/3.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/halloween-draw/images/active3.png')
            }
          ]
        },
        {
          x: 2,
          y: 1,
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/4.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/halloween-draw/images/active4.png')
            }
          ]
        },
        {
          x: 2,
          y: 2,
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/1.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/halloween-draw/images/active1.png')
            }
          ]
        },
        {
          x: 1,
          y: 2,
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/6.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/halloween-draw/images/active6.png')
            }
          ]
        },
        {
          x: 0,
          y: 2,
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/7.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/halloween-draw/images/active7.png')
            }
          ]
        },
        {
          x: 0,
          y: 1,
          imgs: [
            {
              src: require('@/activities/halloween-draw/images/8.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/halloween-draw/images/active8.png')
            }
          ]
        }
      ],
      activeStyle: {
        background: 'transparent'
      },
      isShowRulesDialog: false,
      drawResult: '', //抽獎結果
      candyCostNumber: 500, //抽一次獎話費糖果數量
      balance: 0, //糖果餘額
      drawLoading: false
    };
  },
  computed: {
    buttons() {
      return [
        {
          x: 1,
          y: 1,
          imgs: [
            {
              src: this.drawLoading
                ? require('@/activities/halloween-draw/images/active-button.png')
                : require('@/activities/halloween-draw/images/button.png'),
              width: '100%',
              height: '100%'
            }
          ]
        }
      ];
    }
  },
  methods: {
    // 獲取詳情
    async getDetail() {
      try {
        // this.balance = 500;
        const { data } = await this.$http.get(
          '/activity/getActivityLotteryInfo'
        );
        this.balance = data.crystalBalance || 0;
      } catch (error) {
        console.log(error);
      }
    },
    // 點擊抽獎按鈕
    clickDrawButton() {
      this.drawLoading = true;
      this.$confirm({
        content: '是否花費500個糖果進行抽獎？',
        title: '提示',
        showCancelButton: false,
        confirmButtonText: '確定',
        closeOnClickOverlay: true,
        customClass: 'draw-dialog'
      })
        .then(() => {
          if (this.balance >= this.candyCostNumber) {
            this.getDrawInfo();
          } else {
            // alert('糖果餘額不足');

            this.$confirm({
              content: '抱歉，您當前所擁有的糖果餘額數量不足，無法參與本次抽獎',
              title: '提示',
              showCancelButton: false,
              confirmButtonText: '確定',
              closeOnClickOverlay: true
            });
            this.drawLoading = false;
          }
        })
        .catch(() => {
          this.drawLoading = false;
        });
    },
    // 獲取抽獎結果
    async getDrawInfo() {
      try {
        const { data } = await this.$http.get('/activity/lottery');
        if (data) {
          this.drawResult = data;
          this.startLuck();
        }
        // this.drawResult = 'P02';
        // this.startLuck();
      } catch (error) {
        this.drawLoading = false;
      }
    },

    // 開始抽獎
    startLuck() {
      switch (this.drawResult) {
        case 'P07':
          this.luckIndex = this.notWinIndex(); // 谢谢参与
          break;
        case 'P03':
          this.luckIndex = 1; // 50nicee币
          break;
        case 'P01':
          this.luckIndex = 2; // 150钻石
          break;
        case 'P06':
          this.luckIndex = 3; // 免费下单券
          break;
        case 'P04':
          this.luckIndex = 5; // 100nicee币
          break;
        case 'P02':
          this.luckIndex = 6; // 500钻石
          break;
        case 'P05':
          this.luckIndex = 7; // 半价优惠券
          break;
        default:
          break;
      }
      this.startCallback();
    },
    // 未中獎
    notWinIndex() {
      if (Math.ceil(Math.random() * 10) > 5) {
        return 0;
      } else {
        return 4;
      }
    },

    // 点击抽奖按钮会触发start回调
    startCallback() {
      console.log('startCallback');
      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play();
      // 调用接口异步抽奖
      setTimeout(() => {
        // 调用stop停止旋转并传递中奖索引
        this.$refs.myLucky.stop(this.luckIndex);
      }, 2000);
    },
    // 抽獎結束
    endLuck() {
      this.balance -= this.candyCostNumber;
      this.drawLoading = false;
      if (this.luckIndex === 0 || this.luckIndex === 4) {
        this.$confirm({
          content: '本次你沒有抽到獎品，謝謝參與',
          title: '很遺憾',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      } else {
        let drawName = '';
        switch (this.drawResult) {
          case 'P07':
            drawName = '谢谢参与';
            break;
          case 'P03':
            drawName = '50nicee幣';
            break;
          case 'P01':
            drawName = '150钻石';
            break;
          case 'P06':
            drawName = '免费下单券';
            break;
          case 'P04':
            drawName = '100nicee幣';
            break;
          case 'P02':
            drawName = '500钻石';
            break;
          case 'P05':
            drawName = '半价优惠券';
            break;
          default:
            break;
        }
        // alert(drawName);

        this.$confirm({
          content: `幸運地抽中了：${drawName}x1份`,
          title: '恭喜你！',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      }
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.halloween-draw {
  display: flex;
  justify-content: center;
  background-color: #16001a;
  overflow: visible;
}
.halloween-draw-content {
  width: 375px;
  background: url('./images/halloween-bg.png') no-repeat center center;
  background-size: cover;
  padding-top: 406px;
  display: flex;
  // flex-direction: column;
  justify-content: center;
  .draw {
    width: 350px;
    height: 618px;
    padding: 0 25px;
    .consume,
    .msg {
      font-size: 14px;
      font-weight: 600;
      line-height: 21px;
      color: #ffe2b1;
      margin-bottom: 17px;
    }
    .consume-num {
      color: #ffa60d;
    }
    .msg {
      margin-top: 10px;
      color: #fff;
      font-weight: 400;
    }
    .num-box {
      display: flex;
      justify-content: center;
      position: relative;
      /deep/ .el-dialog {
        border-radius: 14px;
        width: 300px;

        .el-dialog__body {
          font-size: 14px;
          padding-top: 10px;
          .rules-item {
            margin-bottom: 10px;
          }
        }
      }
      // /deep/ .v-modal {
      //   height: calc(100% - 66px);
      // }
    }
    .close {
      width: 20px;
      height: 20px;
      position: absolute;
      right: -10px;
      top: -74px;
    }
    .rules {
      width: 18px;
      height: 18px;
      position: absolute;
      right: 16px;
      top: -5px;
    }
    .num {
      width: 260px;
      height: 84px;
      background: url('./images/num.png') no-repeat;
      background-size: 100% 100%;
      padding: 18px 20px;
      font-size: 28px;
      color: white;
      text-align: right;
    }
  }
  .power {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    margin-top: 112px;
  }
}
</style>
<style>
/* @media screen and (max-width: 599px) {
  .fps-message-box.draw-dialog {
    vertical-align: middle;
  }
} */
</style>
